import React from 'react'
import { GxIcon } from '@garpix/garpix-web-components-react'
import useSWR from 'swr'
import { ITutorText } from '../interfaces'
import {
  tutorContacts,
  tutorEducation,
  tutorGames,
  tutorMinigameTrash,
  tutorMinigame,
  tutorNews,
  tutorTourney
} from '@/images'
import style from '../styles/game.module.scss'
import { api } from '@/api'
import HtmlContent from '@/components/HtmlContent'

const TutorText = ({ step }: ITutorText): React.ReactElement => {
  const { data } = useSWR(
    'getTutorialText',
    api.getTutorialText
  )

  const newText = data?.results ?? {}

  const getText = ({ step }: ITutorText): React.ReactElement | null => {
    switch (step) {
      case 0: {
        const oldText = `Как насчет того, чтобы стать чемпионом? Посмотри какой прекрасный
        город и сколько в нем развлечений! Здесь ты найдешь много всего
        интересного!`
        return (
          <>
            Привет, я <span className={style.text__accent}>Жэка</span>!
            <br />
            <HtmlContent content={newText?.[1] ?? oldText} />
          </>
        )
      }
      case 1: {
        const oldText = `Это интерактивный город с множеством активностей. Двигай карту и
        найди их все.`
        return (
          <>
            <HtmlContent content={newText?.[2] ?? oldText} />
          </>
        )
      }
      case 2: {
        const oldText = 'Сыграй в веселые мини-игры, открой в себе новые таланты!'
        return (
          <>
            <div className={style.tutor__icon_wrap}>
              <div className={style.tutor__icon_container}>
                <div>
                  <GxIcon src={tutorMinigame} className={style.tutor__icon} />{' '}
                  <GxIcon className={style.tutor__icon} src={tutorMinigameTrash} />
                </div>
                <span className={style.tutor__icon_games_text}>Весёлые игры</span>
              </div>
            </div>
            <HtmlContent content={newText?.[3] ?? oldText} />
          </>
        )
      }

      case 3: {
        const oldText = 'Раздел, в котором ты найдешь множество полезных материалов.'
        return (
          <>
            <div className={style.tutor__icon_wrap}>
              <div className={style.tutor__icon_container}>
                <GxIcon className={style.tutor__icon} src={tutorEducation} />
                <span className={style.tutor__icon_sections_text}>Обучение</span>
              </div>
            </div>
            <HtmlContent content={newText?.[4] ?? oldText} />
          </>
        )
      }

      case 4: {
        const oldText = `В этом разделе собраны все самые интересные игры со мной.
        <br /> Попробуй стать чемпионом!`
        return (
          <>
            <div className={style.tutor__icon_wrap}>
              <div className={style.tutor__icon_container}>
                <GxIcon className={style.tutor__icon} src={tutorGames} />
                <span className={style.tutor__icon_sections_text}>Все игры</span>
              </div>
            </div>
            <HtmlContent content={newText?.[5] ?? oldText} />
          </>
        )
      }
      case 5: {
        const oldText = `Здесь ты можешь посоревноваться со своими друзьями в увлекательных
        чемпионатах.`
        return (
          <>
            <div className={style.tutor__icon_wrap}>
              <div className={style.tutor__icon_container}>
                <GxIcon className={style.tutor__icon} src={tutorTourney} />

                <span className={style.tutor__icon_sections_text}>Турниры</span>
              </div>
            </div>
            <HtmlContent content={newText?.[6] ?? oldText} />
          </>
        )
      }
      case 6: {
        const oldText = 'Здесь ты можешь найти свежие новости о жизни проекта и игр.'
        return (
          <>
            <div className={style.tutor__icon_wrap}>
              <div className={style.tutor__icon_container}>
                <GxIcon className={style.tutor__icon} src={tutorNews} />
                <span className={style.tutor__icon_sections_text}>Новости</span>
              </div>
            </div>
            <HtmlContent content={newText?.[7] ?? oldText} />
          </>
        )
      }
      case 7: {
        const oldText = `Остались вопросы?
        <br /> В этом разделе все необходимые контакты.`
        return (
          <>
            <div className={style.tutor__icon_wrap}>
              <div className={style.tutor__icon_container}>
                <GxIcon className={style.tutor__icon} src={tutorContacts} />

                <span className={style.tutor__icon_sections_text}>Контакты</span>
              </div>
            </div>
            <HtmlContent content={newText?.[8] ?? oldText} />
          </>
        )
      }
      default:
        return null
    }
  }

  return <>{getText({ step })}</>
}

export default TutorText
